// extracted by mini-css-extract-plugin
export default {"user-icon-wrapper":"user-icon-wrapper--fpAXh","transparentTable":"transparentTable--SVyJG"};